module.exports = __webpack_public_path__ + "assets/icons/ic_docs_24px.svg";